var labels = {
  my_objects: {
    es: 'Mis Objetos',
    en: 'My Objects'
  },
  subtitle_access: {
    es: 'Lista todas las tablas de bigquery a las que tienes acceso.',
    en: 'List all the BigQuery tables that you have access.'
  },
  subtitle_tables: {
    es: 'Lista todas las tablas de bigquery en las que eres operador.',
    en: 'List all the BigQuery tables on which you are a data operator.'
  },
  subtitle_bterms: {
    es: 'Lista todos los términos de negocio en los que eres operador.',
    en: 'List all the business terms on which you are a data operator.'
  },
  subtitle_datasources: {
    es: 'Lista todos los datasources de Tableau en los que eres operador.',
    en: 'List all the Tableau datasources on which you are a data operator.'
  },
  subtitle_dashboards: {
    es: 'Lista todos los dashboards de Tableau en los que eres operador.',
    en: 'List all the Tableau dashboards on which you are a data operator.'
  },
  subtitle_datasets: {
    es: 'Lista todos los datasets de PowerBI en los que eres operador.',
    en: 'List all the PowerBI datasets on which you are a data operator.'
  },
  subtitle_reports: {
    es: 'Lista todos los reportes de PowerBI en los que eres operador.',
    en: 'List all the PowerBI reports on which you are a data operator.'
  },
  subtitle_reports_lds: {
    es: 'Lista todos los reportes de Looker Data Studio en los que eres operador.',
    en: 'List all the Looker Data Studio reports on which you are a data operator.'
  },
  subtitle_datasources_gds: {
    es: 'Lista todos los datasources de Looker Data Studio en los que eres operador.',
    en: 'List all the Looker Data Studio datasources on which you are a data operator.'
  },
  tablas_objects: {
    nivel: 2,
    table: {
      es: 'Tabla',
      en: 'Table'
    },
    columns: {
      es: 'Columnas',
      en: 'Columns'
    },
    rows: {
      es: 'Filas',
      en: 'Rows'
    },
    creation_date: {
      es: 'Fecha de creación',
      en: 'Creation date'
    },
    expiration_date: {
      es: 'Fecha de expiración',
      en: 'Expiration date'
    },
    environment: {
      es: 'Entorno',
      en: 'Environment'
    },
    bterm: {
      es: 'Término de negocio',
      en: 'Business term'
    },
    definition: {
      es: 'Definición',
      en: 'Definition'
    },
    values: {
      es: 'Valores',
      en: 'Values'
    },
    datasource: {
      es: 'Datasource',
      en: 'Datasource'
    },
    total_tables: {
      es: 'Total de tablas',
      en: 'Total tables'
    },
    rol: {
      es: 'Rol',
      en: 'Role'
    },
    dashboard: {
      es: 'Dashboard',
      en: 'Dashboard'
    },
    views: {
      es: 'Vistas',
      en: 'Views'
    },
    dataset: {
      es: 'Dataset',
      en: 'Dataset'
    },
    report: {
      es: 'Reporte',
      en: 'Report'
    },
    pages: {
      es: 'Páginas',
      en: 'Pages'
    },
    actions: {
      es: 'Acciones',
      en: 'Actions'
    }
  },
  states_objects: {
    nivel: 2,
    no_access: {
      es: 'Aún no tienes accesos',
      en: "You don't have access yet"
    },
    no_access_subtitle: {
      es: 'Una vez que te los proporcionen podrás verlos aquí.',
      en: 'Once they are provided to you, you will be able to see them here.'
    },
    no_tables: {
      es: 'Aún no tienes tablas',
      en: "You don't have tables yet"
    },
    no_tables_subtitle: {
      es: 'Una vez que te las proporcionen podrás verlas aquí.',
      en: 'Once they are provided to you, you will be able to see them here.'
    },
    no_bterms: {
      es: 'Aún no tienes Términos de Negocio',
      en: "You don't have Business Terms yet"
    },
    no_bterms_subtitle: {
      es: 'Una vez que te los proporcionen podrás verlos aquí.',
      en: 'Once they are provided to you, you will be able to see them here.'
    },
    no_datasources: {
      es: 'Aún no tienes Datasources',
      en: "You don't have Datasources yet"
    },
    no_datasources_subtitle: {
      es: 'Una vez que te los proporcionen podrás verlos aquí.',
      en: 'Once they are provided to you, you will be able to see them here.'
    },
    no_dashboards: {
      es: 'Aún no tienes Dashboards de Tableau',
      en: "You don't have Tableau Dashboards yet"
    },
    no_dashboards_subtitle: {
      es: 'Una vez que te los proporcionen podrás verlos aquí.',
      en: 'Once they are provided to you, you will be able to see them here.'
    },
    no_datasets: {
      es: 'Aún no tienes Datasets de PowerBI',
      en: "You don't have PowerBI Datasets yet"
    },
    no_datasets_subtitle: {
      es: 'Una vez que te los proporcionen podrás verlos aquí.',
      en: 'Once they are provided to you, you will be able to see them here.'
    },
    no_reports: {
      es: 'Aún no tienes Reportes de PowerBI',
      en: "You don't have PowerBI Reports yet"
    },
    no_reports_subtitle: {
      es: 'Una vez que te los proporcionen podrás verlos aquí.',
      en: 'Once they are provided to you, you will be able to see them here.'
    },
    no_reports_lds: {
      es: 'Aún no tienes Reportes de Looker Data Studio',
      en: "You don't have Looker Data Studio Reports yet"
    },
    no_reports_lds_subtitle: {
      es: 'Una vez que te los proporcionen podrás verlos aquí.',
      en: 'Once they are provided to you, you will be able to see them here.'
    },
    no_datasources_gds: {
      es: 'Aún no tienes Datasources de Looker Data Studio',
      en: "You don't have Looker Data Studio Datasources yet"
    },
    no_datasources_gds_subtitle: {
      es: 'Una vez que te los proporcionen podrás verlos aquí.',
      en: 'Once they are provided to you, you will be able to see them here.'
    }
  },
  object_type: {
    es: 'Tipo de objeto',
    en: 'Object Type'
  },
  search_filters: {
    es: 'Filtros de Búsqueda',
    en: 'Search Filters'
  },
  text_filter: {
    es: 'Filtro de texto',
    en: 'Text filter'
  },
  update_metadata: {
    es: 'Actualizar metadata',
    en: 'Update metadata'
  },
  copy_id: {
    es: 'Copiar ID de vista',
    en: 'Copy View ID'
  },
  request_access: {
    es: 'Solicitar acceso',
    en: 'Request access'
  },
  sync: {
    es: 'Sincronizar',
    en: 'Sync'
  },
  set_temporal_do: {
    es: 'Establecer operador temporal',
    en: 'Set temporal data operator'
  },
  open_report_lds: {
    es: 'Abrir en Looker Studio',
    en: 'Open in Looker Studio'
  },
  metadata: {
    es: 'Detalles de la metadata ',
    en: 'Table metadata details'
  },
  bigquery: {
    es: 'Ver en BigQuery',
    en: 'See on BigQuery'
  },
  copy_view: {
    es: 'Copiar ID de la vista',
    en: 'Copy View ID'
  },
  manage_access: {
    es: 'Administrar acceso',
    en: 'Manage Access'
  },
  more_actions: {
    es: 'Más acciones',
    en: 'More actions'
  },
  profiling: {
    es: 'Perfilar',
    en: 'Profiling'
  },
  assign_all_do: {
    es: 'Establecer operador temporal a todos los objetos',
    en: 'Assign all objects to temporal operator'
  },
  data_profiling: {
    es: 'Perfilado de datos ',
    en: 'Data profiling'
  },
  execute_profiling: {
    es: 'Ejecutar perfilamiento',
    en: 'Execute profiling'
  },
  choose_profiling: {
    es: 'Elegir regla de perfilamiento',
    en: 'Choose profiling rule'
  },
  access_table: {
    es: 'Tabla de acceso',
    en: 'Access table'
  },
  view_bterm: {
    es: 'Ver término',
    en: 'View Term'
  },
  data_operator: {
    es: 'Operador',
    en: 'Data operator'
  },
  viewer: {
    es: 'Espectador',
    en: 'Viewer'
  }
};
export default labels;